import { useQuery } from "@tanstack/react-query";

import { Chip } from "@/components/Chip/Chip";
import { Skeleton } from "@/components/Skeleton/Skeleton";
import { applicationSettingsQueryOptions } from "@/hooks/useApplicationSettings";
import type { City } from "@/types/types";

type Props = {
  onRecommendationClick: (city: City) => void;
  shouldShow?: (city: City) => boolean;
};

export function CitiesRecommendations({
  onRecommendationClick,
  shouldShow,
}: Props) {
  const {
    data = [],
    isLoading,
    isError,
  } = useQuery({
    ...applicationSettingsQueryOptions(),
    select: (settings) =>
      shouldShow
        ? settings.flightSearch.recommendedCities.filter(shouldShow)
        : settings.flightSearch.recommendedCities,
  });

  if (isError) {
    return null;
  }

  if (!isLoading && data.length === 0) {
    return null;
  }

  return (
    <ul className="mt-4 -mb-2 flex w-full shrink-0 gap-2 overflow-x-auto pb-2">
      {isLoading
        ? [72, 56, 64, 56, 60].map((width, i) => (
            <li key={i} className="shrink-0">
              <Skeleton variant="rounded" width={width} height={32} />
            </li>
          ))
        : data.map((city) => (
            <li key={city.id}>
              <Chip
                label={city.name}
                onClick={() => onRecommendationClick(city)}
                color="neutral"
                variant="outlined"
                shape="pill"
                size="medium"
              />
            </li>
          ))}
    </ul>
  );
}
